import { useTranslation } from 'react-i18next';
import { Languages } from '~/constants/enums';
import { useUpdatePhoneNumberMutation } from '~/redux/api/userApiSlice';

const ToggleWhatsapp = ({
  item,
}: {
  item: {
    id: number;
    phone: {
      number: string;
    };
    whats_app: boolean;
  };
}) => {
  const [updatePhoneNumber, { isLoading: updatePhoneNumberIsLoading }] =
    useUpdatePhoneNumberMutation();

  const { i18n } = useTranslation('app');
  const locale = i18n.language;

  const handleToggleWhatsapp = (e: React.ChangeEvent<HTMLInputElement>) => {
    updatePhoneNumber({
      phoneId: item.id,
      data: { whatsApp: e.target.checked },
    });
  };
  return (
    <>
      <label className=" relative inline-flex cursor-pointer select-none items-center">
        <input
          type="checkbox"
          name="autoSaver"
          className="sr-only"
          checked={item.whats_app}
          disabled={updatePhoneNumberIsLoading}
          onChange={handleToggleWhatsapp}
        />
        <span
          className={` flex h-[18px] w-[32px] items-center rounded-full p-1 duration-200 ${
            item.whats_app ? 'bg-blue' : 'bg-[#e0e0e0]'
          }`}
        >
          <span
            className={`h-[16px] w-[16px] rounded-full bg-white duration-200 ${
              item.whats_app
                ? `${locale === Languages.ARABIC ? '-translate-x-[11px]' : 'translate-x-[11px]'}`
                : `${locale === Languages.ARABIC ? 'translate-x-[3px]' : '-translate-x-[3px]'}`
            }`}
          ></span>
        </span>
      </label>
    </>
  );
};

export default ToggleWhatsapp;
